import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export enum NotificationType {
  Customer = "customer",
  User = "user",
  System = "system",
}

export enum NotificationSubCategory {
  None = "none",
  Report = "report",
}

export enum NotificationLevel {
  Info = "info",
  Warning = "warning",
  Error = "error",
}

export interface NotificationState {
  currentCustomerId: number;
  currentProfileId?: string;
  currentUserId: number;
  notificationList: Notifications[];
}

export interface Notifications {
  id: string;
  type: NotificationType;
  category: string[];
  subCategory: NotificationSubCategory;
  message?: string | null;
  level: NotificationLevel;
  customerId: number;
  userIds: number[];
  createdAt: string;
  createdById: number;
  modifiedAt?: string | null;
  modifiedById?: number | null;
  metadata: {
    profileId?: string;
    profileName?: string;
    internalId?: string;
    description?: string;
  };
  isNotified: boolean;
}

export const notificationInitialState: NotificationState = {
  currentCustomerId: 0,
  currentUserId: 0,
  notificationList: [],
};

export const notificationSlice = createSlice({
  name: "notifications",
  initialState: notificationInitialState,
  reducers: {
    addNotifications: (state, action: PayloadAction<Notifications[]>) => {
      return {
        ...state,
        notificationList: [...state.notificationList, ...action.payload],
      };
    },
    deleteNotifiedNotifications: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        notificationList: state.notificationList.filter(
          (notification) => notification.id !== action.payload
        ),
      };
    },
    updateCurrentProfileId: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        currentProfileId: action.payload,
      };
    },
    updateCurrentCustomerId: (state, action: PayloadAction<number>) => {
      return {
        ...state,
        currentCustomerId: action.payload,
      };
    },
    updateCurrentUserId: (state, action: PayloadAction<number>) => {
      return {
        ...state,
        currentUserId: action.payload,
      };
    },
  },
});

export const {
  addNotifications,
  updateCurrentProfileId,
  updateCurrentCustomerId,
  updateCurrentUserId,
  deleteNotifiedNotifications,
} = notificationSlice.actions;

export default notificationSlice.reducer;
